import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SettingsContext } from "../../contexts";
import { useStoreWriteGuard } from "../../helpers/storeScope";
import { PageLayout, PageHeader } from "../../components/layout";
import { LookbookLibrary } from "../components/lookbook/LookbookLibrary";
import { LISTINGS_TABS, ListingsTabIcon } from "../constants/listingsTabs.jsx";
import "./rc-lookbooks-page.scss";

const TABS = LISTINGS_TABS;

const RCLookbooksPage = () => {
  const { pathname } = useLocation();
  const settings = useContext(SettingsContext);

  const activeTabPath =
    TABS.find((t) => pathname === t.path || pathname.startsWith(t.path + "/"))
      ?.path ?? TABS[1].path;

  const tabs = useMemo(
    () =>
      TABS.map((tab) => ({
        label: tab.label,
        to: tab.path,
        icon: <ListingsTabIcon src={tab.iconSrc} />,
      })),
    []
  );

  // `/listings/lookbooks/new` did not match any route → use `/lookbooks/new`
  // (UpsertLookbook special-cases "new" as the create flow).
  // Blocked from "Master Store" — no single store to save into.
  const { guardProps: storeGuard } = useStoreWriteGuard();

  const actions = useMemo(
    () => [
      { label: "+ New Lookbook", to: "/lookbooks/new", variant: "primary", size: "lg", className: "rc-ui-btn--hero", "data-btn": "lookbook-new", ...storeGuard },
      { label: "+ New Listing", to: "/product/create", variant: "primary", size: "lg", className: "rc-ui-btn--hero", "data-btn": "listing-new", ...storeGuard },
    ],
    [storeGuard]
  );

  return (
    <PageLayout className="rc-lookbooks">
      <PageHeader
        title="Lookbooks"
        description="Create and manage PDF lookbooks for your clients."
        tabs={tabs}
        actions={actions}
        activePath={activeTabPath}
      />

      <LookbookLibrary
        type="listing"
        getEditPath={(lb) => `/lookbooks/${lb.id}?${settings.iframeQueryParams}`}
        emptyDescription="Create your first lookbook to share a branded PDF catalogue with a client."
      />
    </PageLayout>
  );
};

export default RCLookbooksPage;
